// // wrap all iFrames in .content
$('iframe#addOverlay').wrap('<div class="overlayiFrame" />');

//overlay on iframes
$('.overlayiFrame iframe').css("pointer-events","none");
$('.overlayiFrame').click(function () {
    $('.overlayiFrame iframe').css("pointer-events", "auto");
});
$('.overlayiFrame').mouseleave(function () {
    $('.overlayiFrame iframe').css("pointer-events", "none");
});

//Removes 4x6 Metal Sign
$('.option-set ul li a[data-variant-id="7405272039473"]').remove()

//Removes 8x10 Art Prints
// $('.option-set ul li a[data-variant-id="12433617289265"]').hide()

// Hide Metal Signs size variant
// might need to add inventory checker for POD purchases
// but now hidden for later use - 4/5/2018
// from Chance Smith
// $('.option-set ul li a[data-variant-id="31457564871"]').remove()